import { __awaiter } from "tslib";
import apiClient from './apiClient';
export const contactDataPointSearch = (searchData) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield apiClient.post('/api/v2/search', searchData);
    return (data === null || data === void 0 ? void 0 : data.data) || data; // inner data looks like a bug
});
